import { shutdown } from '@intercom/messenger-js-sdk';
import Keycloak, { KeycloakLogoutOptions } from 'keycloak-js';
import { clearAccountReturnLocation } from 'modules/account/utils';

import { forcedLogout, removeAllKeptCopies } from './forcedLogout';
import { logoutToCurrentPage } from './utils';

export const keycloak = new Keycloak({
  realm: 'Natter',
  url: window._env_.VITE_APP_AUTH_URL,
  clientId: 'natter-frontend',
});

const originalLogout = keycloak.logout.bind(keycloak);

keycloak.logout = async (options?: KeycloakLogoutOptions) => {
  shutdown();
  clearAccountReturnLocation();
  // A forced logout passes through here too, and must not erase the copies it has just kept.
  if (!forcedLogout.isInProgress()) removeAllKeptCopies();
  return originalLogout({ redirectUri: window.location.origin, ...options });
};

// keycloak-js calls this itself when it drops the session (a refused token refresh, among others),
// so it is never a logout the user chose.
keycloak.onAuthLogout = () => {
  logoutToCurrentPage(keycloak);
};
